import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, UrlSegment, Router } from "@angular/router";
import { Observable } from "rxjs";

import { AuthenticationService } from "../services/authentication.service";

@Injectable({
  providedIn: "root",
})
export class LoggedInGuard {
  constructor(
    public auth: AuthenticationService,
    public router: Router,
  ) {}

  private async checkIfLoggedAndReturn(_returnUrl?: string) {
    const loggedIn = !!this.auth.getCurrentUser();

    if (!loggedIn) {
      this.router.navigate(["/"]);
    }

    return loggedIn;
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkIfLoggedAndReturn(next.url[0].path);
  }

  canLoad(route: any, _segments: UrlSegment[]): boolean | Observable<boolean> | Promise<boolean> {
    return this.checkIfLoggedAndReturn(route.path);
  }
}
